import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import * as Sentry from "@sentry/react"
import './index.css'
import App from './App.tsx'
import { MonitoringService } from './sentry'
import { registerSW } from 'virtual:pwa-register'

// Initialize Sentry Monitoring (Centralized Architecture)
MonitoringService.init();

// Register Service Worker with error handling
if ('serviceWorker' in navigator) {
  registerSW({
    onRegisterError(error) {
      console.warn('Service Worker registration failed:', error);
    }
  });
}

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

if (!googleClientId) {
  console.error("Missing VITE_GOOGLE_CLIENT_ID in environment variables");
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary 
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 font-sans">
          <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Ups, algo salió mal</h1>
            <p className="text-gray-600 mb-6">Hemos detectado un error inesperado. Nuestro equipo técnico ya ha sido notificado.</p>
            <button 
              onClick={() => window.location.reload()}
              className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors"
            >
              Recargar aplicación
            </button>
          </div>
        </div>
      }
    >
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
